var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#229e45",
    fillRule: "evenodd",
    d: "M.3 0h53.4v40H.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8e509",
    fillRule: "evenodd",
    d: "M27.1 36.3 52.2 20 27 3.7 1.8 20z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b49a3",
    fillRule: "evenodd",
    d: "M38 20a10.6 10.6 0 1 1-21.2 0 10.6 10.6 0 0 1 21.3 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffef",
    fillRule: "evenodd",
    d: "m24 26.4-.4-.2-.3.1V26l-.2-.3h.4l.1-.4.2.3.4.1-.3.3m7.2 2.2-.4-.2-.3.1v-.3l-.2-.3h.4l.2-.4.1.3.4.1-.3.3m-3-2.5-.3-.2-.3.2v-.4l-.2-.2h.4l.1-.3.2.3h.3l-.3.3m7.3-.8-.3-.1-.3.1V24l-.1-.2h.3l.1-.4.2.3.3.1-.3.2M28 22.1l-.4-.2-.3.2v-.4l-.2-.3h.4l.2-.4.1.4h.4l-.3.3m-8.7-3h-.7l.1-.3-.3-.3h.4l.2-.4.1.4h.4l-.3.3m1.1 4.8-.3-.2-.3.1v-.3l-.2-.3h.4l.1-.4.2.4h.4l-.3.3m11-5.6-.3-.2-.3.2v-.4l-.2-.2h.4l.1-.4.2.4h.3l-.3.2m-.5 3.2-.2-.1-.3.1v-.2l-.1-.2h.3v-.3l.2.2h.2l-.1.3m-12 4.2-.2-.2-.2.1v-.2l-.2-.2h.3l.1-.2.1.2h.3l-.2.2M35.2 25l-.1-.1h-.2v-.1l-.1-.2h.2v-.1l.2.1h.2l-.2.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffef",
    fillRule: "evenodd",
    d: "m18.6 24-.2-.2-.2.1v-.2l-.2-.2h.3l.1-.2.1.2h.3l-.2.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffef",
    fillRule: "evenodd",
    d: "m18.6 24-.2-.2-.2.1v-.2l-.2-.2h.3l.1-.2.1.2h.3l-.2.2m3.5.3-.2-.2-.3.1.1-.2-.2-.2h.3v-.2l.2.2h.2l-.1.2m-.4 1.4-.3-.1-.2.1V25l-.1-.2h.2l.2-.3v.3h.3l-.2.2m7.4-2-.2-.1-.2.1v-.2l-.2-.2h.3l.1-.3.1.2h.3l-.2.3m-2.1.2-.2-.1-.3.1v-.4h.2v-.3l.2.2h.2l-.2.3m-5.7-.5-.1-.1h-.2V22h.1v-.2l.1.2h.2l-.1.1M35 26l-.2-.1h-.3v-.4h.2v-.2l.2.2h.2l-.2.2m-1.7.5h-.4v-.3h.1l.1-.3.1.2h.2l-.1.2m.8.2h-.3V26l-.1-.1h.2v-.2l.2.1h.2l-.2.2m2.4-1.9h-.3v-.3h.1v-.2l.2.2h.1v.1m-3.3 3.5-.2-.1h-.3l.1-.1-.2-.2h.3v-.2l.2.2h.2l-.2.2m.1 1.2L33 28l-.2.1V28l-.1-.1h.2l.1-.3.1.2h.2l-.1.2m-1.6-1.9h-.3v-.2l-.1-.1h.1l.1-.2.1.1h.2l-.1.2m-1.5.2h-.4v-.3h.1l.1-.2.1.1h.2l-.1.2m-2.6-2-.1-.1h-.2v-.1l-.1-.2h.2v-.2l.1.2h.2l-.1.2m.3 4.7h-.3v-.3h.1V28l.1.1h.2zM23.9 21l-.3-.2-.3.1v-.4l-.2-.2h.4l.1-.4.2.3.4.1-.3.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m37.4 23.8.4-1.6a26 26 0 0 0-19.8-7l-.8 1.7c9.5-.9 16.4 3.3 20.2 7",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#309e3a",
    d: "m34.8 21 .2.1v.2l.1.2h.2l.1-.1q0-.2-.2-.2l-.1-.3a.3.3 0 0 1 .2-.4h.1l.3.1.2.3v.3l-.3-.2v-.2h-.2v.2l.2.2v.4l-.2.1H35l-.2-.3zm-1-.6.3.1v.3h.3v-.1l-.1-.2-.2-.2a.3.3 0 0 1 .2-.4h.4l.2.3v.3l-.2-.1v-.2h-.1l-.2-.1v.3q.2 0 .3.2v.3l-.2.2h-.2l-.2-.1-.3-.3zm-1.1-.3.6-1 .7.4v.2l-.6-.3-.1.2.5.3-.2.2-.5-.3-.1.2.5.4v.1zM31 18.7v-.2l.5.2-.2.4h-.5l-.3-.2v-.3l.2-.6h.6l.3.2v.3h-.2v-.2l-.2-.1H31l-.2.2v.3l.1.2h.3l.1-.1zm-7.6-1.9.2-1.2.4.1v.8l.4-.7h.3l-.1 1.2h-.3l.2-1-.4.9H24l-.1-1-.1 1zm-1.1-.1v-1.2h1v.3h-.7v.2h.5v.2h-.6v.3h.7v.3zm-3.9-.7v-.4l.3-.2h.2l.5.1.1.5-.2.4-.4.2-.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7ffff",
    d: "m18.6 16 .1.2.2.2.3-.1v-.6l-.3-.2-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#309e3a",
    d: "M19.7 16.5v-1.1h.8l.2.1v.4l-.3.1.1.1.2.2.1.3h-.3l-.2-.3V16H20v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 15.9h.4v-.3H20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#309e3a",
    d: "M21 15.4h.7l.2.2.1.2v.5l-.2.2-.1.1H21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.3 15.6v.8h.3l.1-.1v-.6h-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#309e3a",
    d: "m26.8 17.5.3-1.1h.3l.3.2.1.1v.4l-.3.1h-.4v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.2 16.6v.3h.1l.2.1.1-.1v-.2h-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#309e3a",
    d: "m27.9 17.8.4-1 .4.1.3.1v.6h-.3v.1l.1.2v.3l-.2-.1v-.3l-.1-.2-.2-.1-.2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.3 17.3h.2l.2.1.1-.1v-.1l-.2-.1h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#309e3a",
    d: "m29.2 17.8.2-.3h.1l.2-.1h.3l.3.3v.4q0 .3-.3.4h-.4l-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.5 17.9v.3l.2.2h.2l.2-.3v-.4l-.2-.1h-.2q-.2 0-.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#309e3a",
    d: "m31.5 19.4.6-1 .4.2.2.2v.3l-.1.2h-.3l.1.1v.5l-.2-.1v-.5l-.1-.1H32V19l-.3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32 19h.2l.2.1h.1v-.2l-.2-.1-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#309e3a",
    d: "m35.8 21.6.2-.3h.6l.3.4-.1.5-.4.3-.4-.1-.3-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36 21.7v.5h.3l.3-.1v-.6h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#309e3a",
    d: "m25.5 17 .2-.8.6.2v.1l-.5-.1v.2h.4v.2h-.5v.1l.4.2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBr);
export default __webpack_public_path__ + "static/media/br.31bcf7a84cce95c16d3e39822d1ec99c.svg";
export { ForwardRef as ReactComponent };